import { useAppStoreWithOut } from '@/store/modules/app'

export const useCollect = () => {
  const appStore = useAppStoreWithOut()
  // 添加历史记录
  const addHistory = (item) => {
    const { fullPath, meta, name } = item
    appStore.addHistoryList({
      fullPath,
      name,
      meta: { ...meta }
    })
  }
  return {
    addHistory
  }
}
